import { Controller, useFormContext } from "react-hook-form";
import { CheckboxGroup, CheckboxGroupProps } from "./checkbox-group";

export function ControlledCheckboxGroup<T = string | number>(
  props: Omit<CheckboxGroupProps<T>, "onValueChange" | "errorMessage"> & {
    name: string;
  },
) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => (
        <CheckboxGroup<T>
          {...field}
          onValueChange={field.onChange}
          {...props}
          errorMessage={fieldState?.error?.message}
          isInvalid={!!fieldState?.error?.message}
        />
      )}
    />
  );
}

ControlledCheckboxGroup.displayName = "RecareUI.ControlledCheckboxGroup";
